// import { Timeline } from '@mui/icons-material';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@mui/lab';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';

type CessionHistoryDialogProps = {
  open: boolean;
  onClose: () => void;
  cessions: {
    giver: string;
    cessionary: string;
    cessionDate: string;
    cessionaryIdentifier: string;
    giverIdentifier: string;
  }[];
};

function CessionHistoryDialog({
  open,
  onClose,
  cessions,
}: CessionHistoryDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
        }}
      >
        <Typography variant="h6">Historial de cesiones</Typography>
      </DialogTitle>
      <DialogContent>
        {cessions.length > 1 ? (
          <Timeline position="alternate-reverse">
            {cessions.map((cession, index) => (
              <TimelineItem key={index}>
                <TimelineSeparator>
                  <TimelineDot color="primary" />
                  {index < cessions.length - 1 && <TimelineConnector />}
                </TimelineSeparator>

                <TimelineContent>
                  <Stack spacing={0.5}>
                    <Typography variant="subtitle2">
                      {cession.giver} → {cession.cessionary}
                    </Typography>

                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Fecha de cesión
                      </Typography>
                      <Typography variant="body2">
                        {new Date(cession.cessionDate).toLocaleString()}
                      </Typography>
                    </Box>
                  </Stack>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        ) : (
          <Stack spacing={0.5}>
            <Typography variant="subtitle2">
              {cessions[0]?.giver} → {cessions[0]?.cessionary}
            </Typography>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Fecha de cesión
              </Typography>
              <Typography variant="body2">
                {new Date(cessions[0]?.cessionDate).toLocaleString()}
              </Typography>
            </Box>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default CessionHistoryDialog;
